import { enqueueError } from "./error-queue.service";

declare global {
  interface Window {
    PHN_HEADER_VERSION: string;
    _paq: { push: (args: string[]) => void };
  }
}

class Logger {
  error(id: string, err: Error): void {
    // eslint-disable-next-line no-console
    console.error(err);
    enqueueError(err, id);
  }
}

export default new Logger();
